// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__34pSm","sendOtp":"AuthorizeToLogin_sendOtp__keMru"};